import React from 'react';
import { NavLink } from 'react-router-dom';
function Submenu({ toggleNavbar }) {
    return (
        <div className="submenu">
            <li>
                <NavLink to="/ratings" onClick={toggleNavbar}><div className="submenu_links">Резултати</div></NavLink>
            </li>
            <li>
                <NavLink to="/free-places" onClick={toggleNavbar}><div className="submenu_links">Свободни места</div></NavLink>
            </li>
            {/* Add more submenu items as needed */}
        </div>
    );
}

export default Submenu;